import { render, staticRenderFns } from "./ProductFeaturesBlock.vue?vue&type=template&id=4826c6b9&scoped=true&"
import script from "./ProductFeaturesBlock.vue?vue&type=script&lang=js&"
export * from "./ProductFeaturesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeaturesBlock.vue?vue&type=style&index=0&id=4826c6b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826c6b9",
  null
  
)

export default component.exports